import { combineReducers, configureStore } from '@reduxjs/toolkit';
import policiesReducer from './slices/policiesSlice';
import organizationReducer from './slices/organizationSlice';
import chatReducer from './slices/chatSlice';

// The old authSlice was removed by the app audit: it was never dispatched
// and never selected anywhere - the Supabase session (via supabase.auth /
// RequireAuth) is the single source of auth truth.

const appReducer = combineReducers({
  policies: policiesReducer,
  organization: organizationReducer,
  chat: chatReducer,
});

// Logout must wipe in-memory state, or the previous account's organization,
// policies, and chat history stay visible to the next login in the same tab.
export const RESET_STORE = 'store/reset';
export const resetStore = () => ({ type: RESET_STORE } as const);

const rootReducer: typeof appReducer = (state, action) =>
  appReducer(action.type === RESET_STORE ? undefined : state, action);

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof appReducer>;
export type AppDispatch = typeof store.dispatch;

// Custom hooks for TypeScript
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
